import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sendOnboarding } from '../../common/api/clients/supplierOnboarding.api';
import { queries } from '../../common/api/queryKeys/queries';

export const useSendOnboarding = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (offerId: string) => sendOnboarding(offerId),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: queries.supplierOnboarding._def,
            });
        },
    });
};
